export const getImage = (name, allImageSharp) =>
  allImageSharp.nodes.find(node => node.fluid.originalName === name).fluid.src

export const getImageNode = (name, allImageSharp) =>
  allImageSharp.nodes.find(node => node.fluid.originalName === name).fluid
